export default __webpack_public_path__ + "static/media/applause.1bf027c9.mp3";